export default {
    breadcrumbs: {
        my_companies: 'Moje kompanije',
    },
    buttons: {
        create_company: '+ Kreiraj kompaniju',
    },
    card: {
        pib: 'PIB',
    },
    no_companies: 'Nemate dodatih kompanija',
    no_peronal_info: 'Molimo popunite ime, prezime i telefon',
}
